<ng-container *ngIf="allowSubscription">
	<vb-user-subscription-select *ngIf="userSubscriptionTypes?.length" [subscriptionTypes]="userSubscriptionTypes" (subscriptionChanged)="onSubscriptionChange($event)">
	</vb-user-subscription-select>

	<vb-confirmation-dialog #sparkUnsubscribe [title]="'Media_Videos_Spark_UnsubscribeTitle' | translate" [message]="'Media_Videos_Spark_UnsubscribeMessage' | translate : { '0': sparkSubscription?.roomTitle }" [cancelText]="'Cancel' | translate" [actionText]="'Ok' | translate">
	</vb-confirmation-dialog>
</ng-container>
